import React, { useRef, useState } from "react";
import Button from 'devextreme-react/button';
import Popup from 'devextreme-react/popup';
import SelectBox from 'devextreme-react/select-box';
import List from 'devextreme-react/list';
import useGetReceipts from '../../../../Hooks/useGET/useGetReceipts';
import handleDelReceipt from '../../../../Utils/handleDEL/handleDelReceipt'
import handleFormReceipt from '../../../../Utils/handleFORM/handleFormReceipt'
import { useNavigate } from 'react-router-dom';
import useFetch from '../../../../Hooks/useFetch';
import '../styles.css';
export default function DocumentsTab(orderId) {
    const
        navigate = useNavigate,
        fetch = useFetch(navigate),
        inputRef = useRef(null);

    const
        [popup, setPopup] = useState(false),
        [fileType, setFileType] = useState(0);

    const { receiptData, quoteData, mutate } = useGetReceipts(orderId);

    const onItemDeleted = async (e) => {
        console.log('onItemDeleted e', e);
        const receiptId = e.itemData.id;
        const { response, isDataGood } = await handleDelReceipt(receiptId, fetch);

        if (isDataGood) {
            mutate()
        }
    }

    const uploadReceipt = () => {
        inputRef.current.click();
    }

    const handleFileTypeChange = (e) => {
        setFileType(e.value);
    }

    const handleFileChange = async (event) => {
        console.log('event', event)
        const fileObj = event?.target?.files[0];
        if (!fileObj) {
            return;
        }
        const { response, isDataGood } = await handleFormReceipt(orderId, event.target.files[0], fileObj.name, fileType, fetch);
        console.log('response', response)
        if (isDataGood) {
            mutate();
            setPopup(false);
            event.target.value = null;
        }
       
    };
    
    return (
        <>
            <div className="tabpanel">
                {/*This area is for uploading any receipts or quotes related to this order.*/}
                {receiptData?.length === 0 && quoteData.length === 0 ?
                    <h6 className="noBold">No files uploaded.</h6>
                    :
                    <>
                        <h6>Receipts:</h6>
                        <List
                            dataSource={receiptData}
                            height={150}
                            allowItemDeleting={true}
                            itemDeleteMode="static"
                            itemRender={itemRender}
                            onItemDeleted={onItemDeleted}
                        />
                        <h6>Quotes:</h6>
                        <List
                            dataSource={quoteData}
                            height={150}
                            allowItemDeleting={true}
                            itemDeleteMode="static"
                            itemRender={itemRender}
                            onItemDeleted={onItemDeleted}
                        />
                    </>
                }

                <Popup
                    visible={popup}
                    width="50%"
                    height="auto"
                    hideOnOutsideClick={true}
                    onHiding={() => setPopup(false)}
                    title="Upload Document"
                >
                    <SelectBox
                        dataSource={fileTypes}
                        valueExpr='value'
                        displayExpr='text'
                        onValueChanged={handleFileTypeChange}
                    />
                    <>
                        <input
                            style={{ display: 'none' }}
                            ref={inputRef}
                            type="file"
                            onChange={handleFileChange}
                        />
                    </>
                    <Button className="upload-button" text="Upload Document" onClick={uploadReceipt} />
                </Popup>
                <Button className="doc-button" text="Upload Document" onClick={() => setPopup(true)} />
            </div>
        </>
    );
}

const fileTypes = [
    { value: 0, text: 'Order Receipt' },
    { value: 1, text: 'Quote' }
];

const itemRender = (e) => {
    return (
        <a
            className="hoverLinkText yellow mx-2"
            href={e.url}
            target="_blank"
            rel="noreferrer">
            {e.url.slice(35)}
        </a>
    );
}